import { SubscriptionSimpleModel } from '@models/SubscriptionSimpleModel';
import type { TenantSimple } from '@repositories/tenantRepository/tenant.types';
import { TenantSimpleModel } from '@repositories/tenantRepository/models/TenantSimpleModel';
import type { UserGroupDTO } from '../userGroups.types';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { UserGroupSimpleModel } from './UserGroupSimpleModel';

export class UserGroupModel {
  private readonly _dto: UserGroupDTO;

  constructor(dto?: UserGroupDTO) {
    this._dto = dto ?? {};
  }

  get originDTO(): UserGroupDTO {
    return this._dto;
  }

  get deleted(): boolean {
    return this._dto.deleted || false;
  }

  get description(): string {
    return this._dto.description || '';
  }

  get name(): string {
    return this._dto.name || '';
  }

  get parentUserGroup(): UserGroupSimpleModel {
    return new UserGroupSimpleModel(this._dto.parentUserGroup);
  }

  get properties(): Properties {
    return this._dto.properties || {};
  }

  get subUserGroups(): UserGroupSimpleModel[] {
    return this._dto.subUserGroups?.map(sub => new UserGroupSimpleModel(sub)) || [];
  }

  get subscriptions(): SubscriptionSimpleModel[] {
    return this._dto.subscriptions?.map(subscription => new SubscriptionSimpleModel(subscription)) || [];
  }

  get tenant(): TenantSimpleModel {
    return new TenantSimpleModel(this._dto.tenant ?? {} as TenantSimple);
  }

  get userGroupId(): string {
    return this._dto.userGroupId || '';
  }

  get createdBy(): string {
    return this._dto.createdBy || '';
  }

  get createdDate(): Dayjs {
    return dayjs(this._dto.createdDate);
  }

  get updatedBy(): string {
    return this._dto.updatedBy || '';
  }

  get updatedDate(): Dayjs {
    return dayjs(this._dto.updatedDate);
  }

  get userGroupCode(): string {
    return this._dto.userGroupCode || '';
  }
}
